module.exports = __webpack_public_path__ + "static/media/IMCOMLogin.ec24d03f.png";